import { Heart } from 'lucide-react';
import { Interest } from '../../../types/matching';

interface ProfileInterestsProps {
  interests: Interest[];
}

export function ProfileInterests({ interests }: ProfileInterestsProps) {
  if (!interests || interests.length === 0) return null;

  return (
    <div>
      <div className="flex items-center gap-2.5 mb-4">
        <Heart className="w-5 h-5 text-gray-400 dark:text-gray-500" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Centres d'interet</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {interests.map((interest) => (
          <span
            key={interest.id}
            className="inline-flex items-center gap-2 px-3.5 py-2 rounded-xl bg-gray-50 dark:bg-gray-700/30 border border-gray-100 dark:border-gray-700/50 text-sm font-medium text-gray-700 dark:text-gray-300"
          >
            <span className="text-lg">{interest.icon}</span>
            {interest.name}
          </span>
        ))}
      </div>
    </div>
  );
}
